module.exports = __webpack_public_path__ + "media/categories/1038-bc052c97.svg";